import type { ButtonHTMLAttributes } from 'react';

type Variante = 'primary' | 'ghost' | 'default';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: Variante;
};

const classes: Record<Variante, string> = {
  primary: 'btn btn--primary',
  ghost: 'btn btn--ghost',
  default: 'btn',
};

export function Button({ variante = 'default', className, type, ...rest }: Props) {
  const cls = [classes[variante], className].filter(Boolean).join(' ');
  return <button type={type ?? 'button'} className={cls} {...rest} />;
}
